import React from 'react';
import Select, {components} from "react-select";
import {getSelectorStyles} from "./selectorStyles";
import {SelectOption} from "../select/SelectDropdown";

interface MultiSelectTableFilterDropdownProps<PROPERTY, OPTION_PROPS extends object> {
    value?: PROPERTY[];
    placeholder: string;
    width: number;
    handleChange: (v: PROPERTY[]) => any;
    options: SelectOption<PROPERTY>[];
    isEqual?: (a: PROPERTY, b: PROPERTY) => boolean;
    optionComponent?: React.FC<OPTION_PROPS>;
    getOptionProps?: (value: PROPERTY) => OPTION_PROPS
}

export const MultiSelectTableFilterDropdown = <PROPERTY, OPTION_PROPS extends object>({
                                                                                          value,
                                                                                          placeholder,
                                                                                          width,
                                                                                          handleChange,
                                                                                          options,
                                                                                          isEqual = (a, b) => a === b,
                                                                                          optionComponent: OptionComponent,
                                                                                          getOptionProps
                                                                                      }: MultiSelectTableFilterDropdownProps<PROPERTY, OPTION_PROPS>) => {

    const getSelectOptionsByValue = () => {
        if (Array.isArray(value)) {
            return options.filter(o =>
                value.some(v => isEqual(v, o.value))
            );
        } else {
            return options.find(o => isEqual(o.value, value as PROPERTY)) || null;
        }
    };

    return <Select
        isMulti={true}
        placeholder={placeholder}
        components={(OptionComponent && getOptionProps) && {
            Option: (props: any) => (
                <components.Option {...props}>
                    <OptionComponent {...getOptionProps(props.data.value)} />
                </components.Option>
            ),
            MultiValue: (props: any) => (
                <components.MultiValue {...props}>
                    <OptionComponent {...getOptionProps(props.data.value)} />
                </components.MultiValue>
            )
        }}
        value={getSelectOptionsByValue()}
        onChange={selected => {
            handleChange((selected).map(s => s.value));
        }}
        options={options}
        styles={getSelectorStyles(width)}
    />
}
